import React from 'react';
import { RealtyObjectType } from '@search/filter-enums/enums/RealtyObjectType';
import {
    OfferRoute, SearchRoute, useRouter, SearchMapRoute, ISearchType
} from '@search/offer-search-routes/src';

import { NewBuilding } from '@search/filter-enums/enums/NewBuilding';
import { OfferYMapApiPlacemarkResponseItem } from '../api/placemarkResponse';

export function useOfferYMapUnionItemUrlBuilder({
    multiOfferUrlParams
}: {
    multiOfferUrlParams?:
        Pick<ISearchType, 'region' | 'dealType' | 'categoryType' | 'mapBounds'>
        & {
            rooms?: ISearchType['rooms'];
        };
} = {}) {
    const router = useRouter();
    const offerRoute = router.route(OfferRoute);
    const searchRoute = router.route(SearchRoute);
    const searchMapRoute = router.route(SearchMapRoute);

    const getItemUrl = React.useCallback((info: OfferYMapApiPlacemarkResponseItem) => {
        const searchMapParams = multiOfferUrlParams ?? searchMapRoute.params();

        switch (info.kind) {
            case 'flatMulti':
            case 'roomMulti':
            case 'houseMulti':
            case 'landMulti':
                return searchRoute.url({
                    ...searchMapParams,
                    // metroIds: [],
                    // districtIds: [],
                    // deprecared
                    // addresses: [ info.addressId ],
                    mapBounds: {
                        ...searchMapParams?.mapBounds,
                        geohash: info.geohash
                    }
                });

            case 'land':
                return offerRoute.url({
                    offerId: info.id,
                    categoryType: RealtyObjectType.LAND,
                    dealType: searchMapParams.dealType,
                    region: searchMapParams.region
                });

            case 'house':
                return offerRoute.url({
                    offerId: info.id,
                    categoryType: RealtyObjectType.HOUSE,
                    dealType: searchMapParams.dealType,
                    region: searchMapParams.region
                });

            case 'room':
                return offerRoute.url({
                    offerId: info.id,
                    categoryType: RealtyObjectType.ROOM,
                    dealType: info.dealType,
                    newBuilding: info.isNewBuilding ? NewBuilding.NEW : NewBuilding.UNKNOWN,
                    region: info.regionId
                });

            case 'tagless': return '';

            default:
            case 'flat':
                return offerRoute.url({
                    offerId: info.id,
                    categoryType: RealtyObjectType.FLAT,
                    dealType: info.dealType,
                    newBuilding: info.isNewBuilding ? NewBuilding.NEW : NewBuilding.UNKNOWN,
                    room: info.roomType,
                    region: info.regionId
                });
        }
    }, [ ]);

    return getItemUrl;
}
